import { EditCommonEvent } from '@tencent/mega-sdk-protocols';
import { BaseLocalEditManager } from '../../../core/managers/local-edit-manager.base';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
// import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

export class PCLocalEditManager extends BaseLocalEditManager {
    protected init() {
        this.useEditChannel().then((channel) => {
            channel.subscribe(EditCommonEvent.Save, async ({ saveType }) => {
                // const docInfo = await SlideDataServices.DocInfoManager.promise();
                // if (docInfo.cGlobalPadId) {
                //     const syncManager = await SlideDataServices.SyncManager.promise();
                //     await syncManager.createDoc();
                // } else {
                this.save(saveType);
                // }
            });
        });
    }

    protected getSnackbBar() {
        return Snackbar;
    }

    protected notifyResult() {}

    protected getSsrData() {}
}
